









import { Component, Vue } from "vue-property-decorator";
import SiteForm from "./Components/SiteForm.vue";
import Site from "@/models/site";
import SitesAPI from "@/services/sites";
import { LayoutModule } from "@/store/layout";

@Component({
  components: { SiteForm },
})
export default class EditSite extends Vue {
  site: Site | null = null;
  loading = true;

  created(): void {
    if (this.$route.params.id) this.getSite();
  }

  async save(site: Site): Promise<void> {
    LayoutModule.showLoader();
    try {
      await SitesAPI.updateSite(site);
      LayoutModule.setAlerts({
        text: this.$t("sites.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
    // this.$router.push({ name: "sites" });
  }

  cancel(): void {
    this.$router.push({ name: "sites" });
  }

  async getSite(): Promise<void> {
    LayoutModule.showLoader();
    try {
      const r = await SitesAPI.getSite(this.$route.params.id);
      this.site = r;
    } catch (e) {
      console.log(e);
    } finally {
      LayoutModule.hideLoader();
    }
    this.loading = false;
  }
}
